<template>
      <div @click="toggleCollectStatus" class="collect" :class="{'on':collection}">
        <i class="icon-font bcsxushoucang"></i>
        <span>收藏</span>
      </div>
</template>

<script>
    export default {
      name: "collect",
      props: {
        collection: false
      },
      methods: {
        toggleCollectStatus () {
          this.$emit('bindCollect')
        }
      }
    }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .collect
    color #999999
    font-size 12px
    float right
    cursor pointer
    transition 300ms
    user-select none

    &:hover
      color #666666

    i
      margin-right 2px
      color #b7b9bb

    &.on i
      color #2671b0
</style>



// WEBPACK FOOTER //
// src/components/service/collect.vue